module.exports = __webpack_public_path__ + "static/favicon-a3c65c0bd09eb083b793e416dbc2acb3.png";